import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Link } from "react-router-dom";

export default function AgenziaDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/agency/stats").then((r) => setStats(r.data)); }, []);
  const Card = ({ label, value, to, testid }) => (
    <Link to={to || "#"} data-testid={testid} className="block bg-white border border-[#E6E4E0] p-6 hover:border-[#7D2E3F] transition-colors">
      <div className="label-uppercase text-[#5C5657]">{label}</div>
      <div className="font-serif text-5xl mt-3 text-[#3A3D42]">{value ?? "—"}</div>
    </Link>
  );
  return (
    <div data-testid="agenzia-dashboard">
      <div className="label-uppercase">La mia agenzia</div>
      <h1 className="font-serif text-4xl mt-2 mb-10">Panoramica</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card label="Immobili totali" value={stats?.total} to="/area-agenzie/immobili" testid="stat-total" />
        <Card label="In Galleria" value={stats?.published} to="/area-agenzie/immobili" testid="stat-published" />
        <Card label="Venduti" value={stats?.venduti} to="/area-agenzie/immobili" testid="stat-venduti" />
        <Card label="Richieste totali" value={stats?.lead_totali} to="/area-agenzie/richieste" testid="stat-lead" />
      </div>
      {stats?.lead_nuovi > 0 && (
        <div className="mt-10 border border-[#7D2E3F] bg-[#FDFDFC] p-6" data-testid="new-leads-banner">
          <div className="label-uppercase text-[#7D2E3F] mb-2">Novità</div>
          <div className="font-serif text-xl">Hai {stats.lead_nuovi} {stats.lead_nuovi === 1 ? "richiesta nuova" : "richieste nuove"} da lavorare</div>
          <Link to="/area-agenzie/richieste" className="text-xs label-uppercase text-[#7D2E3F] mt-3 inline-block hover:underline">Vai alle richieste →</Link>
        </div>
      )}
    </div>
  );
}
